export const banner = {
    create: {
      url: "banner/create",
      method: "POST",
      data: null,
    },
    update: {
      url: "banner/update/",
      method: "PUT",
      id: null,
      data: null,
    },
    get: {
      url: "banner/get",
      method: "GET",
      id: null,
      params: null,
    },
    delete: {
      url: "banner/delete/",
      method: "DELETE",
      id: null,
    },
    
  };
  